import { useQuery } from '@tanstack/react-query';
import { tFinancialService } from 'src/infra/services/tFinancialService';

type LegType = 'LEG_ONE' | 'LEG_TWO' | 'LEG_THREE' | 'HUB';

/**
 * Hook to fetch charge domains for a specific deviation and leg type
 * @param deviationId - The ID of the deviation
 * @param legType - The leg type to filter charge domains (optional)
 * @param enabled - Whether to enable the query (default: true)
 */
export const useChargeDomainsByDeviation = (deviationId?: string, legType?: LegType, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['charge-domains', deviationId, legType],
    queryFn: async () => {
      if (!deviationId) {
        return { data: [] };
      }

      const response = await tFinancialService.api.getChargeDomains(deviationId, legType ? { 'leg-type': legType } : undefined);

      return response.data;
    },
    enabled: enabled && !!deviationId,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    retry: 1,
  });
};
